import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { Component } from '@angular/core';
import { StateService } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { DemoHasAccessService } from '@client/app/modules/demodata/services/demo-has-access.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { HeatmapsDashboardComponent } from './dashboard/dashboard.component';

@Component({
    selector: 'base-heatmaps',
    template: `<ui-view></ui-view>`,
    standalone: true,
    imports: [UIRouterModule],
})
class BaseHeatmapsComponent {}

export const HEATMAPS_STATES: Ng2StateDeclaration[] = [
    {
        name: 'base.customer.heatmaps',
        url: '/heatmaps',
        abstract: true,
        component: BaseHeatmapsComponent,
        data: { title: 'Acquia Web Governance - Heatmaps' },
        resolve: [
            {
                token: 'hasAccess',
                deps: [
                    ActiveFeatureService,
                    StateService,
                    DemoHasAccessService,
                    MonUIRouterTransitionService,
                ],
                resolveFn: async (
                    ng2ActiveFeatureService: ActiveFeatureService,
                    $state: StateService,
                    ng2DemoHasAccessService: DemoHasAccessService,
                    ng2MonUIRouterTransitionService: MonUIRouterTransitionService,
                ) => {
                    if (ng2DemoHasAccessService.isDemoHeatmaps() || ng2ActiveFeatureService.isFeatureActive('admin_heatmaps')) {
                        return Promise.resolve(true);
                    }

                    ng2MonUIRouterTransitionService.onTransitionFinished(
                        () => {
                            $state.go('base.customer.domain.dashboard', $state.params);
                        },
                    );

                    // Return a rejected promise to prevent the route from continuing
                    return Promise.reject(new Error('Access denied'));
                },
            },
            {
                token: 'titleTranslation',
                deps: [TranslateService],
                resolveFn: async (translateService: TranslateService) => {
                    return translateService.getString('Acquia Web Governance - Heatmaps');
                },
            },
        ],
    },
    {
        name: 'base.customer.heatmaps.dashboard',
        url: '',
        component: HeatmapsDashboardComponent,
        data: {},
    },
];
